<template>
   <main class="main login-page">
      <div class="main-wrapper">
        <div class="container">
          <div class="center">
            <div class="left-up">
              <div @click="$parent.closeSignInModal" class="desc back">
                  {{ $t('Back to mainpage') }}
              </div>
              <div class="form">
                <div class="tabs">
                  <router-link to="/login" class="title regular" v-text="$t('LOGIN')" />
                  <router-link to="/register" class="title regular" v-text="$t('SIGN UP')" />
                </div>
                <div class="form-wrapper">
                  <div class="form-fields login-content">
                    <div class="form-fields-wrapper">
                      <label>
                      <div class="desc">{{ $t('Email') }}:</div>
                      <input v-on:keyup.enter="submitLogin" type="email" :placeholder="$t('Email')" v-model="email"/>
                      </label>
                      <label>
                      <div class="desc">{{ $t('Password') }}:</div>
                      <input v-on:keyup.enter="submitLogin" type="password" :placeholder="$t('Password')" v-model="pass"/>
                      </label>            
                      <router-link to="/recover" class="link" v-text="$t('Forgot password?')" />
                      <div class="cta-container">
                      <button class="button" @click="submitLogin">
                        <span><span>[</span> {{ $t('LOGIN') }} <span>]</span></span>
                      </button>
                      </div>
                      <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  
  export default {
    name: 'Login',
    props: [],
    components: {
    },
    data: function() {
      return {
        email: '',
        pass: ''
      }
    },
    mounted() {
      
    },
    methods: {
      submitLogin() {
        let loginData = {
          "username": this.email,
          "password": this.pass
        }
        this.$emit('login', loginData)
      },
    }
  }
  </script>